export type { PressableProps } from '../components/pressable';
export { default } from '../components/pressable';
